import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'globalSearch',
    standalone:true
})
export class GlobalSearchPipe implements PipeTransform {

    transform(items: any[], searchText: string): any[] {
        if (!Array.isArray(items) || !searchText) {
            return items;
        }

        searchText = searchText.toLowerCase();

        return items.filter(item => this.searchItem(item, searchText));
    }

    private searchItem(item: any, searchText: string): boolean {
        if (typeof item === 'string' || typeof item === 'number') {
            return item.toString().toLowerCase().includes(searchText);
        }

        if (Array.isArray(item)) {
            // If item itself is an array, search inside every element
            return item.some(subItem => this.searchItem(subItem, searchText));
        }

        if (typeof item === 'object' && item !== null) {
            // Search inside all properties of the object
            return Object.values(item).some(value => this.searchItem(value, searchText));
        }

        return false;
    }
}